import {IRestService} from "./IRestService";
import {IVendorService} from "./IVendorService";

export class VendorService implements IVendorService {
    
    public constructor(private readonly restService: IRestService) {
    }

    public async getAllVendors(): Promise<any[]> {
        return this.restService.get(`vendors`);
    }

    public async getVendorById(id: string): Promise<any> {
        return this.restService.get(`vendors/${id}`);
    }

    public async createVendor(vendor: any): Promise<any> {
        return this.restService.post(`vendors`, vendor);
    }

    public async updateVendor(vendor: any): Promise<any> {
        return this.restService.put(`vendors/${vendor.id}`, vendor);
    }

    public async deleteVendor(id: string): Promise<void> {
        return this.restService.delete(`vendors/${id}`);
    }

    public async searchVendors(searchTerm: string): Promise<any[]> {
        return this.restService.get(`vendors/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    public async getAllPaymentTerms(): Promise<any[]> {
        return this.restService.get(`payment-terms`);
    }

    public async createPaymentTerms(paymentTerms: any): Promise<any> {
        return this.restService.post(`payment-terms`, paymentTerms);
    }

    public async updatePaymentTerms(paymentTerms: any): Promise<any> {
        return this.restService.put(`payment-terms/${paymentTerms.id}`, paymentTerms);
    }

    public async deletePaymentTerms(id: string): Promise<void> {
        return this.restService.delete(`payment-terms/${id}`);
    }

    // SalesLogSource (Dealers) methods
    public async getSalesLogSources(): Promise<any[]> {
        return this.restService.get(`vendors/sales-log-sources`);
    }

    public async getSalesLogSourceById(id: string): Promise<any> {
        return this.restService.get(`vendors/sales-log-sources/${id}`);
    }

    public async createSalesLogSource(source: any): Promise<any> {
        return this.restService.post(`vendors/sales-log-sources`, source);
    }

    public async updateSalesLogSource(source: any): Promise<any> {
        return this.restService.put(`vendors/sales-log-sources/${source.id}`, source);
    }

    public async deleteSalesLogSource(id: string): Promise<void> {
        return this.restService.delete(`vendors/sales-log-sources/${id}`);
    }
}

